import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatINR } from "../lib/products";
import { CardColorSwatches } from "./CardColorSwatches";

export default function ProductCard({ product, span = "md:col-span-4", showColors = false }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      className={`af-card relative group overflow-hidden ${span}`}
      data-testid={`product-card-${product.slug}`}
    >
      <div
        className="absolute top-0 left-0 right-0 h-[3px] z-10"
        style={{ background: product.team_color }}
      />
      <div className="relative aspect-square overflow-hidden bg-black">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
        <div className="absolute top-4 left-4 af-mono text-[10px] uppercase tracking-[0.25em] text-white/80">
          {product.team_label}
        </div>
        <div className="absolute bottom-4 right-4 w-10 h-10 border border-white/30 inline-flex items-center justify-center bg-black/40 backdrop-blur-sm group-hover:bg-[#FF2800] group-hover:border-[#FF2800] transition-colors">
          <ArrowUpRight size={16} strokeWidth={1.5} />
        </div>
      </div>
      <div className="p-6 flex items-end justify-between gap-4">
        <div>
          <h3 className="af-display text-xl md:text-2xl font-bold uppercase tracking-tight leading-none">
            {product.name}
          </h3>
          <p className="text-zinc-400 text-sm mt-2 line-clamp-1">
            {product.tagline}
          </p>
          {showColors && (
            <CardColorSwatches slug={product.slug} colors={product.color_options} />
          )}
        </div>
        <div className="text-right">
          {product.price_tba ? (
            <>
              <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                Price
              </p>
              <p
                className="af-display text-lg font-bold leading-tight text-[#FFD700]"
                data-testid={`price-tba-${product.slug}`}
              >
                TBA
              </p>
              <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">
                Dropping soon
              </p>
            </>
          ) : (
            <>
              <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                From
              </p>
              {product.sale_percent > 0 && (
                <p className="af-mono text-[11px] text-zinc-500 line-through leading-none">
                  {formatINR(product.original_price_inr)}
                </p>
              )}
              <p className="af-display text-xl font-bold leading-tight">
                {formatINR(product.price_inr)}
              </p>
              {product.sale_percent > 0 && (
                <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-[#FF2800] mt-1">
                  {Math.round(product.sale_percent)}% OFF
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
